import { useMutation } from "@tanstack/react-query";
import { authApi } from "../../api/endpoints";

export function useLogin() {
  return useMutation({
    mutationFn: (data: { email: string; password: string }) =>
      authApi.login(data).then((r) => r.data),
  });
}
